import { TEXT_INPUT_DEFAULT_MAX_LENGTH, TEXT_INPUT_DEFAULT_MIN_LENGTH } from '@Components/Input/const';

export function validateMinTextLength(lengthValue, minValue = TEXT_INPUT_DEFAULT_MIN_LENGTH) {
  return lengthValue >= minValue;
}

export function validateMaxTextLength(lengthValue, maxValue = TEXT_INPUT_DEFAULT_MAX_LENGTH) {
  return lengthValue <= maxValue;
}
